import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserStore } from 'src/app/stores/user.store';
import { environment } from 'src/environments/environment';

export const adminGuard: CanActivateFn = () => {
  if (!environment.production) {
    return true;
  }

  const userStore = inject(UserStore);

  return userStore.currentUserIsAdmin();
};